type FormatDate = (date: Date, options: Intl.DateTimeFormatOptions) => string;
type FormatMessage = (descriptor: { id: string }) => string;

export const formatPaymentDate = (
  date: string | undefined,
  formatDate: FormatDate,
  formatMessage: FormatMessage
): string | undefined => {
  if (!date) return undefined;

  const parsedDate = new Date(date);
  const day = formatDate(parsedDate, { day: 'numeric' });
  const month = formatDate(parsedDate, { month: 'short' }).replace('.', '');
  const year = formatDate(parsedDate, { year: 'numeric' });
  const time = formatDate(parsedDate, { hour: '2-digit', minute: '2-digit', hour12: false });
  const dateAt = formatMessage({ id: 'statusPage.dateAt' });

  return `${day} ${month} ${year} ${dateAt} ${time}`;
};
